import { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDarkMode, setIsDarkMode] = useState(() => {
    const saved = localStorage.getItem('cloudgm_theme');
    if (saved) return saved === 'dark';
    return true; // Default to dark mode
  });

  useEffect(() => {
    const root = document.documentElement;
    
    if (isDarkMode) {
      root.classList.add('dark');
      root.classList.remove('light');
      // Dark mode colors
      root.style.setProperty('--bg-primary', '#0a0a0a');
      root.style.setProperty('--bg-surface', '#141414');
      root.style.setProperty('--bg-card', '#1a1a1a');
      root.style.setProperty('--text-primary', '#ffffff');
      root.style.setProperty('--text-secondary', '#9CA3AF');
      root.style.setProperty('--text-muted', '#6B7280');
      root.style.setProperty('--border-color', '#27272a');
      root.style.setProperty('--border-light', 'rgba(255, 255, 255, 0.1)');
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
      // Light mode colors
      root.style.setProperty('--bg-primary', '#ffffff');
      root.style.setProperty('--bg-surface', '#f8fafc');
      root.style.setProperty('--bg-card', '#ffffff');
      root.style.setProperty('--text-primary', '#0f172a');
      root.style.setProperty('--text-secondary', '#64748b');
      root.style.setProperty('--text-muted', '#94a3b8');
      root.style.setProperty('--border-color', '#e2e8f0');
      root.style.setProperty('--border-light', 'rgba(0, 0, 0, 0.1)');
    }
    
    localStorage.setItem('cloudgm_theme', isDarkMode ? 'dark' : 'light');
    window.dispatchEvent(new CustomEvent('themeChange', { detail: { isDarkMode } }));
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(prev => !prev);
  };

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
